// All needed imports
import { BtnTooltipModel } from '../core/models/btn.tooltip.model';
import { SelectModel } from '../core/models/select.model';
import { Numbers } from './constants';

/**
 * setRadioCardModel
 * @param priority - priority
 * @param valueName - value
 * @param value2 - value2
 * @returns obj
 */
export const setRadioCardModel = (priority: number, valueName: string, value2?: string) => {
  let tmpValue: string = valueName;
  if (value2) { tmpValue = value2; }
  return {
    priority,
    title: `${tmpValue}.title`,
    subTitle: `${tmpValue}.subTitle`,
    price: `${valueName}.price`,
    desc1: `${tmpValue}.desc1`,
    desc2: `${valueName}.desc2`,
    desc3: `${valueName}.desc3`,
    textOpenModal: `${valueName}.textOpenModal`,
    coverage: {
      title: `${tmpValue}.modal.title`,
      subTitle: `${valueName}.modal.subTitle`,
      closeBtnName: `${valueName}.modal.close-boton`,
      description: `${valueName}.modal.description`,
      collapsibleList: [
        {
          title: `${valueName}.collapse.title`,
          description: `${valueName}.collapse.description`
        },
        {
          title: `${valueName}.collapse2.title`,
          description: `${valueName}.collapse2.description`
        }
      ]
    }
  };
};

/**
 * SetCalendarModel
 * @param date - date
 * @param dateStart - dateStart
 * @param time - time
 * @returns obj
 */
export const setCalendarModel = (date: any, dateStart: any, time: any) => {
  return {
    linkFormPath: ['incomingStudentsTravelAsistance', `${dateStart}`],
    minDate: date,
    required: true,
    requiredText: `${time}.error`,
    placeholder: `${time}`,
    value: ''
  };
};

/**
 * setCheckboxModel
 * @param linkFormPath - linkFormPath
 * @param label - label
 * @param isChecked - checked
 * @param errorText - error
 * @param tooltip - tooltip
 * @returns obj
 */
export const setCheckboxModel = (linkFormPath: string[], label: string, isChecked: boolean, errorText?: string, tooltip?: {}) => {
  if (!errorText) {
    errorText = null;
  }

  if (!tooltip) {
    tooltip = {};
  }

  return {
    linkFormPath,
    label,
    checked: isChecked,
    error: errorText,
    tooltip
  };
};

/**
 * SetSelectModel
 * @param linkFormPath - linkFormPath
 * @param select - select
 * @param options - options
 * @param tooltip - tooltip
 * @returns obj
 */
export const setSelectModel = (linkFormPath: any, select: any, options: any, tooltip?: any): any => {
  return {
    linkFormPath,
    select,
    options,
    tooltip
  };

};

/**
 * setBtnTooltip
 * @param label - label
 * @param title - title
 * @returns obj
 */
export const setBtnTooltip: (label: string, title: string) => BtnTooltipModel = (label: string, title: string): BtnTooltipModel => {
  return new BtnTooltipModel({
    label,
    title
  });
};

/**
 * setSelectValue
 * @param label - label
 * @param title - title
 * @returns obj
 */
export const setSelectValue = (label: string, errorText?: string, labelClass?: string):
  { label: string, error: string; labelClass: string; } => {
  if (!errorText) {
    errorText = null;
  }

  if (!labelClass) {
    labelClass = null;
  }

  return {
    label,
    error: errorText,
    labelClass
  };
};

/**
 * setSelectOptions
 * @param selected - selected
 * @param label - label
 * @param list - list
 * @param multipleValues - multiple
 * @returns obj
 */
export const setSelectOptions = (selected: string, label: string, list: any[], multipleValues?: any): any => {
  if (!multipleValues) {
    multipleValues = null;
  }

  return {
    default: {
      selected,
      label,
      disabled: false
    },
    list,
    multiple: multipleValues
  };
};

export const setInputModel = (linkFormPath: any, label: any, otherProps: any, required = false, disabled = false): any => {
  return {
    linkFormPath,
    label,
    required,
    disabled,
    ...otherProps
  };
};

export const setRadioModel = (label: string, text: string, isChecked?: boolean): any => {
  if (!isChecked) {
    isChecked = null;
  }

  return {
    label,
    text,
    checked: isChecked
  };
};

export const setRadioPointModel = ( linkFormPath: string [], idNumber: string, otherProps: any, checked: boolean): any => {
  return {
    linkFormPath,
    id: idNumber,
    checked,
    ...otherProps
  };
};

export const setSelectModuleTable = (value: string) => {
  return {
    linkFormPath: ['incomingStudentsTravelAsistance', 'guaranteeSelection', `${value}`],
    select: {},
    options: {
      list: [{ name: '0 €', id: -1 }, { name: '20.000 €', id: Numbers.number0 }, { name: '30.000 €', id: Numbers.number1 }]
    }
  };
};

export const setTableRow = (linkFormPath: any, guarantee: any, limit: any, extendGuarantee: any) => {
  return {
    linkFormPath,
    guarantee,
    limit,
    extendGuarantee,
    included: { yes: { classNameIcon: 'icon-ok' }, no: { classNameIcon: 'icon-error' } }
  };
};

// Revisar donde se usa esta funcion y adaptarlo para usar setTableRow
export const setTableRowToRW = (text: string, money: string, value: any) => {
  return {
    linkFormPath: ['incomingStudentsTravelAsistance', 'guaranteeSelection', `${value}`],
    guarantee: `${text}`,
    limit: `${money}`,
    extendGuarantee: new SelectModel(setSelectModuleTable(`${value}`)),
    included: {
      yes: {
        classNameIcon: 'icon-ok'
      },
      no: {
        classNameIcon: 'icon-error'
      }
    }
  };
};

export const getFutureDate: (plusDays: number, plusYears?: number) => Date = (plusDays: number, plusYears?: number): Date => {
  const currentDate: Date = new Date();

  let auxYears: number = currentDate.getFullYear();
  if (plusYears) {
    auxYears = currentDate.getFullYear() + 1;
  }

  currentDate.setDate(currentDate.getDate() + plusDays);
  return new Date((currentDate.getMonth() + 1) + '/' + currentDate.getDate() + '/' + auxYears);
};
